import { UntypedFormBuilder } from '@angular/forms';
import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs';
import { ConfigSection } from '../config-section';
import { ListerConfiguration } from '@admin/models/system-configuration-model';
import { OverviewService } from '@feature/overview/services/overview.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { IOverviewTileModel } from '@feature/overview/models/overview-tile-model';
import { SelectItem } from 'primeng/api';
import { ListerConfigurationService } from '@admin/services/lister-configuration.service';

@Component({
  selector: 'mojo-lister-configuration',
  templateUrl: './mojo-lister-configuration.component.html'
})
export class MojoListerConfigurationComponent extends ConfigSection<ListerConfiguration> {

  readonly productName: string = MojoWellKnownNames.Products.MojoDashboard;
  allTiles: Observable<IOverviewTileModel[]>;
  selectableTiles: SelectItem[] = [];

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly overviewService: OverviewService,
    private readonly listerConfigurationService: ListerConfigurationService
  ) {
    super();
    this.allTiles = this.overviewService.getOverviewTilesByProductName(this.productName).pipe(map(x => x.AllTiles));
  }


  initialiseConfig(): Observable<ListerConfiguration> {
    return of({ config: [] });
  }

  createForm(listerConfig: ListerConfiguration): void {
    this.form = this.formBuilder.group({
      listerConfiguration: [listerConfig.config]
    });
  }

  submit(): Observable<boolean> {
    const config = this.form.getRawValue();
    return this.listerConfigurationService.saveListerConfiguration(config.listerConfiguration, this.productName)
      .pipe(
        map(() => true)
      );
  }
}
